module.exports = __webpack_public_path__ + "media/images/icon__info--white@3x-9e8f9e95235f23a9b7b429c48ddd1db6.png";